import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VocabularyService, PlatformService } from '@core/services';
import { DestroyableComponent } from '@models/destroyable.component';
import { ErrorNotificationService } from '@shared/error-notification/error-notification.service';
import { Vocabulary as VocabularyContent, VocabularyTerm, IVocabularyStudyOptions } from 'lingo2-models';
import { OnUiButtonState } from 'onclass-ui';
import { takeUntil } from 'rxjs/operators';
interface IStudyTermOption {
  term: VocabularyTerm;
  is_checked: boolean;
}

@Component({
  selector: 'app-vocabulary-options',
  templateUrl: './vocabulary-options.component.html',
  styleUrls: ['./vocabulary-options.component.scss'],
})
export class VocabularyOptionsComponent extends DestroyableComponent {
  @Input() set vocabulary(vocabulary: VocabularyContent) {
    this._vocabulary = vocabulary;
    this.loadVocabularyStudy();
  }
  public termOptions: IStudyTermOption[];
  public saveButton: OnUiButtonState = 'default';
  protected _vocabulary: VocabularyContent;
  protected _vocabularyStudyOptions: IVocabularyStudyOptions;
  @Output() selected = new EventEmitter<IVocabularyStudyOptions>();

  constructor(
    public errorNotificationService: ErrorNotificationService,
    private vocabularyService: VocabularyService,
    protected readonly platform: PlatformService,
  ) {
    super(platform);
  }

  protected createForm() {
    this.termOptions = this._vocabulary.terms.map((term) => ({
      term,
      is_checked: !!this._vocabularyStudyOptions.term_id.includes(term.id),
    }));
  }

  protected loadVocabularyStudy() {
    if (!this._vocabulary.id) {
      return;
    }

    this.vocabularyService
      .getVocabularyOptions(this._vocabulary.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (options) => {
          this._vocabularyStudyOptions = options;
          this.createForm();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public get selectedTermsCount(): number {
    return (this.termOptions || []).filter((option) => option.is_checked).map((option) => option.term.id).length;
  }

  public get saveAndPlayTitle(): string {
    return `Учить слова (${this.selectedTermsCount})`;
  }

  public saveAndPlay() {
    this.saveButton = 'progress';
    const term_id = this.termOptions.filter((option) => option.is_checked).map((option) => option.term.id);

    this.vocabularyService
      .setVocabularyOptions(this._vocabulary.id, { term_id })
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (options) => {
          this._vocabularyStudyOptions = options;
          this.selected.emit(options);
          this.saveButton = 'done';
          this.resetButtonState();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
          this.saveButton = 'fail';
          this.resetButtonState();
        },
      });
  }

  protected resetButtonState() {
    this.setTimeout(() => {
      this.saveButton = 'default';
    }, 1500);
  }

  public trackByFn(index) {
    return index;
  }
}
